module.exports = __webpack_public_path__ + "img/watermark.e79f4221.svg";